<template>
  <div class="container-fluid">
    <div class="heightcontainer ">
        <landing-navbar></landing-navbar>
        <user-profile-page></user-profile-page>
        <div class="centerbtn col-12">
        <button class="toparroabtn shadow mouseoverbtn2 d-flex mx-auto float-lg-right" @click="navToSignUp">
            <img src="../../assets/logofav.jpg" alt="logo" class="borderradiushalf borderwhite" width="25px">
            <span class="proximanova-semibold fontsize16 white my-auto ml-2">Create Free Profile</span> 
        </button>
        </div>
    </div>    
    <!-- <Footer class="footer" ></Footer> -->
  </div> 
</template>
<script>
import Footer from '../LandingFooter.vue'
import selectedJobDetails from '../../components/SelectedJobDetails.vue'
import router from '../../router.js'
import LandingNavbar from './Navbar.vue'
import userProfilePage from '../WelcomePage.vue'
import $ from 'jquery'
export default {
  components: {
    Footer,
    LandingNavbar,
    userProfilePage,
    selectedJobDetails
  },
  data() {
    return {
    };
  },
  methods: {
    navToSignUp() {
        this.$session.clear()
        router.push({
            name : 'signup'
        })
    }
  },
  mounted: function() {
    window.scrollTo(0, 0)
  },
};
</script>
<style scoped>
.whitecircle{
    height: 25px;
    width: 25px;
    border: 1px solid white;
    border-radius: 50%;
}
.centerbtn{
position: fixed;
    bottom: 0;
    margin-bottom: 60px;
    z-index: 5 !important;
}
.toparroabtn{
    border-radius: 100px;
    background: #007AFE;
    border: none;
    /* position: fixed;
    bottom: 0; */
    /* right: 0 !important; */
    margin-right: 2% !important;
    
    /* margin-bottom: 60px; */
    padding: 6px 15px;
}
section {
 margin: 0 0 0rem 0rem  !important ;
}
.footer {
  background-color: black;       
  color : white;
  position: sticky;
}
@media screen and (max-width : 768px) {
    .toparroabtn{
        border-radius: 100px;
        background: #007AFE;
        border: none;
        /* position: fixed;
        bottom: 0; */
        margin-right: 18%;
        z-index: 5 !important;
        /* margin-bottom: 60px; */
        padding: 6px 15px;
        /* margin-right: 5% !important; */
        margin: 0 auto !important;
    }
}
</style>
